<template>
  <div>
    <breadcrumbs :back="[{text:'Scheduling',to:{name:'PlanningScheduling'}}]" home="Templates"/>

    <v-list-item>
    </v-list-item>

    <v-data-table ref="table" class="purtrak-table"
        hide-default-footer disable-pagination :headers="activeHeaders" :items="templates"
        :show-expand="!$vuetify.breakpoint.mobile"
        @dblclick:row="(e,info) => {template=info.item;action='Edit';drawer=true}">
      <template v-slot:header.action v-if="!readOnly">
        <v-btn fab color="primary" small @click="activityAdd()"><v-icon>mdi-plus</v-icon></v-btn>
      </template>
      <template v-slot:item.action="{item}">
        <v-menu :nudge-width="150" offset-y :nudge-left="150">
          <template v-slot:activator="{ on }">
            <v-btn small v-on="on" v-if="$vuetify.breakpoint.mobile" outlined>Operations</v-btn>
            <v-btn small icon v-on="on" v-on:click.prevent v-else><v-icon small>mdi-dots-vertical</v-icon></v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="template=item;action='Edit';drawer=true"><v-list-item-title>Edit template</v-list-item-title></v-list-item>
            <v-list-item @click="template=item;action='Copy';drawer=true"><v-list-item-title>Copy template</v-list-item-title></v-list-item>
            <v-list-item v-if="item.hasSubActivities" @click="activityAdd(item)"><v-list-item-title>Add subactiviy</v-list-item-title></v-list-item>
            <v-divider/>
            <v-list-item @click="template=item;showDelete=true"><v-list-item-title>Delete template</v-list-item-title></v-list-item>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:item.type="{item}">{{type(item)}}</template>
      <template v-slot:item.data-table-expand="{ item, isExpanded, expand }">
        <v-icon v-if="item.hasSubActivities" @click="expand(!isExpanded)">{{isExpanded?'mdi-chevron-up':'mdi-chevron-down'}}</v-icon>
        <v-icon v-if="item.hasSubActivities" color="primary" @click="expand(true);activityAdd(item)">mdi-plus-circle</v-icon>
      </template>
      <template v-slot:expanded-item="{ item, headers }" v-if="!$vuetify.breakpoint.mobile">
        <td :colspan="headers.length" class="pa-0">
          <v-simple-table>
            <tbody>
              <tr v-for="sub of item.subActivities" :key="sub.id" @dblclick="template=sub;action='Edit';drawer=true">
                <td :width="headers[0].width"/>
                <td :width="headers[1].width"><div class="pl-4"><v-icon small class="mr-1">mdi-arrow-right</v-icon>{{sub.description}}</div></td>
                <td :width="headers[2].width">
                  <div class="pl-4">
                    <v-icon small class="mr-1">mdi-arrow-right</v-icon>
                    {{type(sub)}}
                    <span class="text-caption">(offset {{sub.offsetDays}} days, duration {{sub.duration | duration}})</span>
                  </div>
                </td>
                <td :width="headers[3].width" class="text-center">
                  <v-menu :nudge-width="150" offset-y :nudge-left="150">
                    <template v-slot:activator="{ on }">
                      <v-btn small icon v-on="on" v-on:click.prevent><v-icon small class="pl-4">mdi-dots-vertical</v-icon></v-btn>
                    </template>
                    <v-list dense>
                      <v-list-item @click="template=sub;action='Edit';drawer=true"><v-list-item-title>Edit activity</v-list-item-title></v-list-item>
                      <v-list-item @click="template=sub;action='Copy';drawer=true"><v-list-item-title>Copy activity</v-list-item-title></v-list-item>
                      <v-list-item @click="template=sub;showDelete=true"><v-list-item-title>Delete activity</v-list-item-title></v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </td>
      </template>
    </v-data-table>

    <v-navigation-drawer v-model="drawer" right temporary absolute width="450" stateless>
      <planning-scheduling-activity :activity="template" :action="action" toTemplate @close="drawer=false;activity={}" @refresh="refresh();drawer=false;activity=null"/>
    </v-navigation-drawer>

    <delete-object v-model="showDelete" name="this template" @delete="performDeleteTemplate"/>
  </div>
</template>

<script>
import PlanningSchedulingActivity from '@/views/planning/scheduling/PlanningSchedulingActivity'

export default {
  name: 'PlanningSchedulingTemplates',
  components: {PlanningSchedulingActivity},
  data() {
    return {
      drawer: false,
      action: '',
      filters: {
      },
      templates: [],
      template:  {},
      showDelete: false,
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    readOnly() {
      return !this.company.permissions.includes('production.write');
    },
    audit() {
      return this.company.allowAudit && this.company.permissions.includes('audit');
    },
    filteredList() {
      return this.templates.filter(transaction => {
        return true;
      });
    },
    activeHeaders() {
      const headers = this.$vuetify.breakpoint.mobile ? [] : [{ text: '', value: 'data-table-expand', width:'10%',sortable:false,print:false}];
      headers.push({ text: 'DESCRIPTION', value: 'description', width:'45%',sortable:true});
      headers.push({ text: 'TYPE', value: 'type', width:'40%',sortable:true});
      headers.push({ text: '' , value:'action', width:'5%',sortable:false,align:'center',print:false});
      return headers;
    }
  },
  created() {
    this.refresh();
  },
  methods: {
    async refresh() {
      this.loading = true;
      const results = await this.$apiCall(`query PlanningSchedulingTemplates {
                                              activityTemplates {
                                                ...activityFields
                                                subActivities {
                                                  ...activityFields
                                                }
                                              }
                                            }
                                            fragment activityFields on Activity {
                                              id,description,startDate,endDate,duration,color,quantity,primitiveId,siteId,template
                                              dependsOn,outstandingDependents,
                                              hasSubActivities,parentId,offsetDays,equipment
                                              materials {type,id,quantity}
                                              roleId,assignTo,completed
                                            }`,
                                          {});
      if (!results.error)
        this.templates = results.data.activityTemplates;
      this.loading = false;
    },
    type(template) {
      if (template.hasSubActivities)
        return 'Group';
      if (template.primitiveId)
        return 'Action';
      return 'Ad-hoc';
    },
    activityAdd(parent) {
//      if (parent && !parent.expanded)
//        this.toggleExpandActivity(parent);
      this.action = 'Add';
      this.template = {primitiveId:null,template:true,description:'', startDate:'2020-01-01',duration:60,color:'#00ff00FF',quantity:0,dependsOn:[],
                       hasSubActivities:false,parentId:parent?.id,offsetDays:0,equipment:[],materials:[],assignTo:[],roleId:''};
      this.drawer = true;
    },
    async performDeleteTemplate() {
      this.loading = true;
      const results = await this.$apiCall(`mutation PlanningSchedulingTemplates($id: ID!) {
                                             objectDelete(id:$id)
                                           }`,
                                          {id:this.template.id});
      this.loading = false;
      if (!results.error) {
        this.showDelete = false;
        await this.refresh();
        this.$store.commit('setError', {type:'success',message:`Deleted ${this.template.description} template`});
      }
    }
  }
}
</script>